import { defineMessages } from '../define';

export default defineMessages({
  'result.notFound': { ru: 'Проект не найден.', en: 'Project not found.' },
  'result.toProjects': { ru: 'К проектам', en: 'To projects' },
  'result.expired.title': { ru: 'Срок хранения истёк', en: 'Storage period has ended' },
  'result.expired.text': {
    ru: 'Результаты хранятся до 90 дней с момента создания проекта. Файлы этого проекта уже удалены. Можно повторить генерацию с новыми материалами.',
    en: 'Results are kept for up to 90 days after a project is created. This project\'s files have already been deleted. You can generate again with new footage.',
  },
  'result.newProject': { ru: 'Новый проект', en: 'New project' },
  'result.title.plain': { ru: 'Результат', en: 'Result' },
  'result.noEdl.title': { ru: 'Монтажное решение ещё не готово', en: 'The edit isn\'t ready yet' },
  'result.noEdl.hint': {
    ru: 'Как только монтаж завершится, здесь появится готовый ролик.',
    en: 'Your finished reel will appear here as soon as the edit is done.',
  },
  'result.refresh': { ru: 'Обновить', en: 'Refresh' },

  'result.confirm.illustrations': {
    ru: 'Смонтировать ролик заново с новыми иллюстрациями? Их расставим по смыслу рассказа. Оформление сохранится, ручные правки нарезки, хука и субтитров — нет.',
    en: 'Re-edit the reel with the new illustrations? We\'ll place them to match the story. Your styling is kept, but manual changes to cuts, hook and subtitles are not.',
  },
  'result.title.lead': { ru: 'Ролик ', en: 'Your reel is ' },
  'result.title.accent': { ru: 'готов', en: 'ready' },

  'result.sources.summary': { ru: 'Исходные записи · {n}', en: 'Source clips · {n}' },
  'result.sources.used': { ru: 'Использована целиком', en: 'Used in full' },
  'result.sources.partial': { ru: 'Использована частично · {duration}', en: 'Partly used · {duration}' },
  'result.sources.unused': { ru: 'Не вошла в монтаж', en: 'Not used in the edit' },
  'result.sources.restore': { ru: 'Вернуть запись целиком', en: 'Restore the full clip' },

  'result.preview.unavailable': {
    ru: 'Превью ролика недоступно — ссылка на файл ещё не выдана. Отправьте ролик в чат или обновите экран.',
    en: 'Preview unavailable: the file link hasn\'t been issued yet. Send the reel to the chat or refresh the screen.',
  },
  'result.fact.duration': { ru: 'Длительность', en: 'Duration' },
  'result.fact.format': { ru: 'Формат, MP4', en: 'Format, MP4' },
  'result.download': { ru: 'Скачать', en: 'Download' },
  'result.toStory': { ru: 'В историю', en: 'Share to story' },
  'result.toStory.telegramOnly': {
    ru: '«В историю» работает только внутри Telegram.',
    en: 'Sharing to a story only works inside Telegram.',
  },
  'result.music.attribution': {
    ru: 'Для этой музыки нужна подпись в описании. Скачайте ролик и опубликуйте его вместе с авторством; быстрая отправка в историю недоступна.',
    en: 'This music requires credit in the caption. Download the reel and publish it with the attribution; quick sharing to stories is unavailable.',
  },

  'result.again.title': { ru: 'Смонтировать ещё раз', en: 'Re-edit' },
  'result.again.text': {
    ru: 'Измените нужные настройки — мы заново смонтируем ролик с выбранным оформлением.',
    en: 'Change any settings and we\'ll re-edit the reel with your new styling.',
  },

  'result.hook.title': { ru: 'Хук', en: 'Hook' },
  'result.hook.show': { ru: 'Показывать хук', en: 'Show hook' },
  'result.hook.text': { ru: 'Текст хука', en: 'Hook text' },
  'result.hook.placeholder': { ru: 'Фраза на первые секунды', en: 'A line for the first seconds' },
  'result.cover.title': { ru: 'Заголовок обложки', en: 'Cover title' },
  'result.cover.placeholder': { ru: 'Заголовок на обложке', en: 'Title on the cover' },
  'result.hookStyle.title': { ru: 'Оформление хука', en: 'Hook style' },
  'result.hookStyle.hint': {
    ru: 'Выбранный стиль появится в видео после «Смонтировать ещё раз»',
    en: 'The chosen style will appear in the video after "Re-edit"',
  },

  'result.subtitles.title': { ru: 'Субтитры', en: 'Subtitles' },
  'result.subtitles.style': { ru: 'Стиль субтитров', en: 'Subtitle style' },
  'result.typing.title': { ru: 'Звук печати', en: 'Typing sound' },
  'result.typing.hint': { ru: 'Применится после повторного монтажа ролика', en: 'Applied when the reel is re-edited' },
  'result.subtitleColor.title': { ru: 'Цвет субтитров', en: 'Subtitle color' },
  'result.color.title': { ru: 'Цвет видео', en: 'Video color' },
  'result.color.hint': { ru: 'Настройки применятся при повторном монтаже ролика', en: 'Applied when the reel is re-edited' },
  'result.transitions.title': { ru: 'Переходы', en: 'Transitions' },
  'result.transitions.hint': { ru: 'Применятся после повторного монтажа', en: 'Applied when the reel is re-edited' },
  'result.zooms.title': { ru: 'Зумы на акцентах', en: 'Emphasis zooms' },
  'result.zooms.hint': { ru: 'Короткое приближение и возврат к общему плану', en: 'A quick zoom in and back out to the wide shot' },
  'result.noise.title': { ru: 'Шумоподавление', en: 'Noise reduction' },
  'result.noise.hint': {
    ru: 'Можно изменить и повторить монтаж для сравнения',
    en: 'Change it and re-edit to compare',
  },
  'result.music.volume': { ru: 'Громкость музыки', en: 'Music volume' },
  'result.music.title': { ru: 'Музыка', en: 'Music' },
  'result.music.hint': { ru: 'Подложка приглушается под голосом.', en: 'The track is ducked under your voice.' },

  'result.cutaways.title': { ru: 'Врезки', en: 'Cutaways' },
  'result.cutaways.none': { ru: 'В этом ролике врезок нет.', en: 'This reel has no cutaways.' },
  'result.cutaways.shift': { ru: ' (сдвиг {value} с)', en: ' (shifted {value} s)' },
  'result.cutaways.removedBadge': { ru: 'убрана', en: 'removed' },
  'result.cutaways.earlier': { ru: '← сдвинуть', en: '← Earlier' },
  'result.cutaways.later': { ru: 'сдвинуть →', en: 'Later →' },
  'result.cutaways.restore': { ru: 'Вернуть', en: 'Restore' },
  'result.cutaways.remove': { ru: 'Убрать', en: 'Remove' },
  'result.cutaways.keep': { ru: 'Оставить этот кадр', en: 'Keep this shot' },

  'result.illustrations.title': { ru: 'Иллюстрации', en: 'Illustrations' },
  'result.illustrations.text': {
    ru: 'Добавьте видео или фото — при новом монтаже расставим их по смыслу рассказа, как при первом запуске.',
    en: 'Add videos or photos and the next edit will place them to match the story, just like the first run.',
  },
  'result.illustrations.existing': { ru: 'Уже в проекте: {n}', en: 'Already in the project: {n}' },
  'result.illustrations.add': { ru: 'Добавить иллюстрации · {count}/{max}', en: 'Add illustrations · {count}/{max}' },
  'result.illustrations.hint': { ru: 'Видео и фото для врезок', en: 'Videos and photos for cutaways' },
  'result.illustrations.max': { ru: 'Добавлено максимум иллюстраций.', en: 'Maximum number of illustrations added.' },

  'result.fix.title': { ru: 'Слово в субтитрах', en: 'Fix a subtitle word' },
  'result.fix.text': {
    ru: 'Замените слово или фразу, уже звучащую в ролике. В поле «как слышно» введите точный текст из расшифровки; добавить новую реплику здесь нельзя.',
    en: 'Replace a word or phrase that is already spoken in the reel. In "as heard", enter the exact text from the transcript; you can\'t add new lines here.',
  },
  'result.fix.from': { ru: 'как слышно', en: 'as heard' },
  'result.fix.to': { ru: 'как надо', en: 'should be' },
  'result.fix.add': { ru: 'Добавить', en: 'Add' },
  'result.fix.draft': {
    ru: 'Замены пока в черновике. Чтобы добавить их в видео, нажмите «Смонтировать ещё раз» внизу.',
    en: 'Replacements are still a draft. To apply them to the video, tap the re-edit button below.',
  },
  'result.fix.matches': { ru: 'совпадений: {n}', en: 'matches: {n}' },
  'result.fix.notFoundBadge': { ru: 'не найдено в ролике', en: 'not found in the reel' },
  'result.fix.remove': { ru: 'Убрать', en: 'Remove' },
  'result.fix.toast.phraseDraft': {
    ru: 'В словах ролика не найдена фраза «{phrase}». Проверьте текст в расшифровке.',
    en: 'The phrase "{phrase}" wasn\'t found in the reel. Check the transcript text.',
  },
  'result.fix.toast.noChange': {
    ru: 'Такая замена не изменит субтитры.',
    en: 'This replacement won\'t change the subtitles.',
  },
  'result.apply.toast.subtitlesOff': {
    ru: 'Субтитры выключены. Включите их, чтобы замена появилась в ролике.',
    en: 'Subtitles are off. Turn them on to see the replacement in the reel.',
  },
  'result.apply.toast.phraseMissing': {
    ru: 'В словах ролика не найдена фраза «{phrase}». Укажите в поле «как слышно» точный текст из расшифровки.',
    en: 'The phrase "{phrase}" wasn\'t found in the reel. In "as heard", enter the exact text from the transcript.',
  },
  'result.apply.toast.unchanged': {
    ru: 'Замена «{from}» на «{to}» не изменит субтитры.',
    en: 'Replacing "{from}" with "{to}" won\'t change the subtitles.',
  },

  'result.publish.title': { ru: 'Описание и хэштеги', en: 'Caption and hashtags' },
  'result.publish.caption': { ru: 'Описание поста', en: 'Post caption' },
  'result.publish.hashtags': { ru: 'хэштеги через пробел', en: 'hashtags separated by spaces' },
  'result.publish.copy': { ru: 'Скопировать', en: 'Copy' },
  'result.publish.copied': { ru: 'Описание с авторством музыки скопировано.', en: 'Caption with music credit copied.' },
  'result.publish.copyFailed': {
    ru: 'Не удалось скопировать. Выделите описание и подпись музыки вручную.',
    en: 'Couldn\'t copy. Select the caption and music credit manually.',
  },

  'result.delivered': { ru: 'Ролик уже отправлен в чат с ботом.', en: 'The reel has already been sent to your chat with the bot.' },
  'result.deliver': { ru: 'Отправить в чат', en: 'Send to chat' },

  'result.sourcesGone': {
    ru: 'Исходники удалены по истечении 7 дней. Готовый ролик можно скачать или отправить в чат, повторный монтаж недоступен.',
    en: 'Source files were deleted after 7 days. You can still download the finished reel or send it to the chat, but re-editing is unavailable.',
  },
  'result.watermarked.note': {
    ru: 'Ролик собран по пробному монтажу с водяным знаком. Пересборка без знака стоит 1 монтаж; при ошибке резерв вернётся.',
    en: 'This reel comes from a trial edit and has a watermark. Rebuilding without it costs 1 edit; if it fails, the reserve is returned.',
  },
  'result.trial.note': {
    ru: 'Пробный монтаж завершён. Новый монтаж или пересборка этого ролика стоит 1 монтаж; при ошибке резерв вернётся.',
    en: 'The trial edit is done. A new edit or rebuild of this reel costs 1 edit; if it fails, the reserve is returned.',
  },
  'result.cost': { ru: ' · 1 монтаж', en: ' · 1 edit' },
  'result.newEdit': { ru: 'Новый монтаж', en: 'New edit' },
  'result.newEdit.confirm': {
    ru: 'Смонтировать ролик заново? Дубли и склейки будут выбраны заново, ручные правки нарезки не сохранятся.',
    en: 'Re-edit the reel from scratch? Takes and cuts will be picked again, and manual changes to the cuts will be lost.',
  },
  'result.newEdit.hint': {
    ru: 'Заново разберёт запись и выберет дубли. Оформление из настроек сохранится.',
    en: 'Re-analyzes the recording and picks takes again. Your styling settings are kept.',
  },
  'result.illustrations.uploading': { ru: 'Загружаем иллюстрации', en: 'Uploading illustrations' },
  'result.illustrations.checkUploads': { ru: 'Проверьте загрузку файлов', en: 'Check the file uploads' },
  'result.rebuild.applyUnmark': { ru: 'Применить и убрать знак · 1 монтаж', en: 'Apply and remove watermark · 1 edit' },
  'result.rebuild.withChanges': { ru: 'Пересобрать с изменениями', en: 'Rebuild with changes' },
  'result.rebuild.removeMark': { ru: 'Убрать водяной знак · 1 монтаж', en: 'Remove watermark · 1 edit' },
  'result.rebuild.video': { ru: 'Пересобрать видео', en: 'Rebuild video' },
  'result.rebuild.confirmMark': {
    ru: 'Пересобрать этот ролик без водяного знака? Спишется 1 монтаж, нарезка и оформление не изменятся.',
    en: 'Rebuild this reel without the watermark? 1 edit will be used; cuts and styling stay the same.',
  },
  'result.rebuild.confirm': {
    ru: 'Пересобрать ролик с той же нарезкой?',
    en: 'Rebuild the reel with the same cuts?',
  },
  'result.rebuild.confirmCost': { ru: ' Спишется 1 монтаж.', en: ' 1 edit will be used.' },
});
